import { LAYOUTS } from "@voltmoney/types";
import SharedPropsService from "../../../SharedPropsService";
import { ROUTE } from "../../../routes";
import { WIDGET } from "@voltmoney/schema";
import { ACTION } from "./types";
import { continueAction, fetchCollaterals, goBack, handleCloseOtpModal, resendOtp, verifyOtp } from "./action";
import { getContactUsDetails } from "../../../configs/utils";
export const template = (height, contactUsDetails, userData, getLoanDetails, isFromForeclosureFlow, showNewForeclosure) => ({
    layout: {
        id: ROUTE.FORECLOSURE_NEW,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: "confirmLoanDetails",
                type: WIDGET.CONFIRM_LOAN_DETAILS,
            },
        ],
    },
    datastore: {
        confirmLoanDetails: {
            height,
            contactUsDetails,
            getLoanDetails,
            userData,
            goBackAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.CONFIRM_LOAN_DETAILS,
                payload: { isFromForeclosureFlow, showNewForeclosure }
            },
            collateralDetailsAction: {
                type: ACTION.FETCH_COLLATERALS,
                routeId: ROUTE.CONFIRM_LOAN_DETAILS,
            },
            continueAction: {
                type: ACTION.CONTINUE,
                payload: {},
                routeId: ROUTE.CONFIRM_LOAN_DETAILS,
            },
            action: {
                type: ACTION.VERIFY_OTP,
                payload: {},
                routeId: ROUTE.CONFIRM_LOAN_DETAILS,
            },
            otpAction: {
                type: ACTION.RESEND_OTP,
                payload: {},
                routeId: ROUTE.CONFIRM_LOAN_DETAILS,
            },
            handleCloseOtpModalAction: {
                routeId: ROUTE.CONFIRM_LOAN_DETAILS,
                type: ACTION.CLOSE_OTP_MODAL,
                payload: {}
            },
        },
    },
});
export const confirmLoanDetailsMf = {
    onLoad: async ({ getHeight, instrumentTrack }, { getLoanDetails, isFromForeclosureRasonPage, showNewForeclosure, isFromForeclosureFlow }) => {
        const userData = await SharedPropsService.getUser();
        const contactUsDetails = await getContactUsDetails();
        await instrumentTrack('CONFIRM_LOAN_ACCOUNT_PAGE_VIEWED');
        return Promise.resolve(template(getHeight(), contactUsDetails, userData, getLoanDetails, isFromForeclosureFlow, showNewForeclosure));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.FETCH_COLLATERALS]: fetchCollaterals,
        [ACTION.VERIFY_OTP]: verifyOtp,
        [ACTION.RESEND_OTP]: resendOtp,
        [ACTION.CLOSE_OTP_MODAL]: handleCloseOtpModal,
        [ACTION.CONTINUE]: continueAction,
    },
};
